/**
 * BoLegacyRedirect — Redirection intelligente des anciennes URLs /bo/* vers
 * les nouvelles URLs par rôle (Phase 30, refonte back-office).
 *
 * Mapping :
 *   /bo                           → selon rôle
 *   /bo/secretariat/eleves        → /secretariat/eleves
 *   /bo/secretariat/enseignants   → /secretariat/enseignants
 *   /bo/secretariat/planning      → /secretariat/planning
 *   /bo/mon-planning              → /enseignant/planning (ou legacy /espace-pro)
 *   /bo/eleve                     → /eleve  (ou /espace-eleve legacy)
 *   /bo/admin/inbox               → /admin/contact-requests
 *   /bo/admin/*                   → /admin/dashboard
 */
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useApp } from '../contexts/AppContext';

function pickTargetFromRole(role) {
  if (role === 'admin') return '/admin/dashboard';
  if (role === 'secretaire') return '/secretariat/planning';
  if (role === 'enseignant') return '/moniteur/planning';
  if (role === 'eleve') return '/eleve/dashboard';
  return '/login';
}

function mapLegacy(pathname, role) {
  const p = pathname.replace(/\/+$/, '').toLowerCase();
  if (p === '/bo' || p === '') return pickTargetFromRole(role);
  if (p.startsWith('/bo/secretariat/eleves')) return '/secretariat/eleves';
  if (p.startsWith('/bo/secretariat/enseignants')) return '/secretariat/enseignants';
  if (p.startsWith('/bo/secretariat/planning')) return '/secretariat/planning';
  if (p.startsWith('/bo/secretariat')) return '/secretariat/planning';
  if (p.startsWith('/bo/mon-planning')) return role === 'admin' ? '/moniteur/planning' : '/moniteur/planning';
  if (p.startsWith('/bo/eleve')) return role === 'admin' ? '/eleve/dashboard' : '/eleve/dashboard';
  if (p.startsWith('/bo/admin/inbox')) return '/admin/contact-requests';
  if (p.startsWith('/bo/admin')) return '/admin/dashboard';
  return pickTargetFromRole(role);
}

export default function BoLegacyRedirect() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useApp() || {};
  const role = user?.role || 'guest';

  useEffect(() => {
    const target = mapLegacy(location.pathname, role);
    navigate(target, { replace: true });
  }, [location.pathname, role, navigate]);

  return (
    <div className="min-h-[50vh] flex items-center justify-center text-muted-foreground text-sm" data-testid="bo-legacy-redirect">
      Redirection vers le nouveau back-office…
    </div>
  );
}
